import { useHistory, useLocation } from "react-router-dom";

const useUpdateSearchParams = () => {
  const navigate = useHistory();
  const location = useLocation();

  return (params: Record<string, string | null>) => {
    const searchParams = new URLSearchParams(location.search);

    Object.entries(params).forEach(([key, value]) => {
      if (value === null) {
        searchParams.delete(key);
      } else {
        searchParams.set(key, value);
      }
    });

    navigate.replace({
      pathname: location.pathname,
      search: searchParams.toString(),
    });
  };
};

export default useUpdateSearchParams;
